import GreenpeaceLogoWhite from './greenpeace-white.svg';
import GreenpeaceLogoGreen from './greenpeace-green.svg';
import FacebookLogo from './facebook.svg';
import FacebookOrangeLogo from './facebook-orange.svg';
import TwitterLogo from './twitter.svg';
import TwitterOrangeLogo from './twitter-orange.svg';
import InstagramLogo from './instagram.svg';
import InstagramOrangeLogo from './instagram-orange.svg';
import WhatsappLogo from './whatsapp.svg';
import EmailLogo from './email.svg';
import PeopleIcon from './people.svg';
import SelectArrowIcon from './select-arrow.svg';
import TickIcon from './tick.svg';
import LockIcon from './lock.svg';
import XIcon from './x.svg';
import WarningIcon from './warning.svg';
import WSIcon from './wsIcon.webp';

export const _ = {
  GreenpeaceLogoWhite,
  GreenpeaceLogoGreen,
  FacebookLogo,
  FacebookOrangeLogo,
  TwitterLogo,
  TwitterOrangeLogo,
  InstagramLogo,
  InstagramOrangeLogo,
  WhatsappLogo,
  EmailLogo,
  PeopleIcon,
  SelectArrowIcon,
  TickIcon,
  LockIcon,
  XIcon,
  WarningIcon,
  WSIcon,
};

export default _;
